import { Component, Prop, Vue } from 'vue-property-decorator';
import AnnotationBadges from '@/components/elements/AnnotationBadges.vue';
import AvailabilityStatus from '@/components/elements/AvailabilityStatus.vue';
import Price from '@/components/elements/Price.vue';
@Component({
    name: 'CalendarDay',
    components: { Price, AvailabilityStatus, AnnotationBadges },
})
export default class default_1 extends Vue {
    @Prop({ required: true })
    dayOfMonth;
    @Prop({ required: true })
    day;
    @Prop({ required: true })
    displayPrices;
    @Prop()
    capacityThreshold;
    @Prop()
    focusedDate;
    get enabled() {
        return this.day.enabled;
    }
    get shouldDisplayPrices() {
        return this.displayPrices && this.day.price !== undefined;
    }
    get isFocused() {
        return this.focusedDate && this.focusedDate.isSame(this.day.date);
    }
    onClick() {
        if (this.enabled) {
            this.$emit('input', this.day);
        }
    }
    onFocus() {
        if (this.enabled)
            this.$emit('focus', this.day);
    }
    get isAvailabilityDisplayed() {
        return this.capacityThreshold && this.day.available !== undefined && this.day.available < this.capacityThreshold;
    }
}
